/** The platter: machined disc, strobe band, felt slipmat and spindle. */

import * as THREE from 'three';
import { DIM } from '../../geometry/dims.ts';
import type { DeckMaterials } from '../materials.ts';
import { cyl } from '../shapes.ts';

export function buildPlatter(root: THREE.Group, M: DeckMaterials): THREE.Group {
  const group = new THREE.Group();
  group.position.set(DIM.platter.x, DIM.platterY, DIM.platter.z);
  root.add(group);

  const platter = new THREE.Mesh(
    cyl(DIM.platter.r, DIM.platter.r - 0.15, DIM.platter.h, 128),
    M.aluminium,
  );
  platter.castShadow = true;
  platter.receiveShadow = true;
  group.add(platter);

  const strobeBand = new THREE.Mesh(
    cyl(DIM.platter.r + 0.03, DIM.platter.r + 0.03, 1.0, 128, true),
    M.strobe,
  );
  strobeBand.position.y = -DIM.platter.h / 2 + 0.62;
  group.add(strobeBand);

  const platterTop = new THREE.Mesh(
    new THREE.RingGeometry(2.2, DIM.platter.r - 0.1, 128),
    M.aluminium,
  );
  platterTop.rotation.x = -Math.PI / 2;
  platterTop.position.y = DIM.platter.h / 2 + 0.001;
  group.add(platterTop);

  const mat = new THREE.Mesh(cyl(DIM.platter.r - 0.35, DIM.platter.r - 0.35, 0.22, 96), M.felt);
  mat.position.y = DIM.platter.h / 2 + 0.11;
  mat.receiveShadow = true;
  group.add(mat);

  const spindle = new THREE.Mesh(cyl(0.33, 0.36, 3.4, 24), M.chrome);
  spindle.position.y = DIM.platter.h / 2 + 1.5;
  spindle.castShadow = true;
  group.add(spindle);

  const tip = new THREE.Mesh(new THREE.SphereGeometry(0.33, 20, 12), M.chrome);
  tip.position.y = DIM.platter.h / 2 + 3.2;
  group.add(tip);

  return group;
}
